// extracted by mini-css-extract-plugin
export var equalColumn = "_if-0";